module.exports = __webpack_public_path__ + "img/cenprot.59bcd02e.png";